import type { FreeSlot } from '@hedepy/common/schemas/modules/schedule/freeSlot'
import { type Dayjs } from 'dayjs'

import { type ServiceType } from '@/legacy-src/types/GeneralStateType'
import type { TherapistType } from '@/legacy-src/types/TherapistStateType'
import { formatDateWithDayName } from '@/legacy-src/utilities/date'
import { getTranslate } from '@/legacy-src/utilities/i18n'

import { Heading } from '@/src/domains/design-system/components/Heading'
import { Text } from '@/src/domains/design-system/components/Text'

import { ClientBookingAvailableSlot } from './ClientBookingAvailableSlot'

interface ClientBookingAvailableSlotsUIProps {
  day: Dayjs
  service: ServiceType
  therapist: TherapistType
  slots: FreeSlot[]
}

export const ClientBookingAvailableSlotsUI = ({
  day,
  service,
  therapist,
  slots,
}: ClientBookingAvailableSlotsUIProps) => {
  const { t } = getTranslate()

  return (
    <section className="flex flex-col gap-3">
      <div className="flex items-baseline justify-between">
        <div className="flex flex-col gap-4">
          <Heading element="h2" variant="xl">
            {t('component.calendar.availableSlots')}
          </Heading>
          <Text element="p">{formatDateWithDayName(day)}</Text>
        </div>
        <Text element="p">{t('general.appointments.duration', { duration: service.duration })}</Text>
      </div>
      <div className="flex flex-wrap gap-3">
        {slots.map((slot) => (
          <ClientBookingAvailableSlot key={slot.id} therapist={therapist} slot={slot} service={service} />
        ))}
      </div>
    </section>
  )
}
